import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";




function getSpinner() {
  return '<div class="spa-icon-loading icon-loader-72"></div>';
}





const helpers = {







  spinner: function spinnerHelper(jcr) {
    if (!jcr) {
      throw new Error('No spinner JCR objects provided to helper-spinner.');
    }

    const pageLevel = jcr.pageLevel ? jcr.pageLevel === true : false;
    const loadingMessage = jcr.loadingMessage ? jcr.loadingMessage : '';
    const errorTitle = jcr.errorTitle ? jcr.errorTitle : '';
    const errorMessage = jcr.errorMessage ? jcr.errorMessage : '';
    const cancelTitle = jcr.cancelTitle ? jcr.cancelTitle : '';
    const cancelMessage = jcr.cancelMessage ? jcr.cancelMessage : '';
    const cancelDisabled = jcr.cancelDisabled ? jcr.cancelDisabled : false;
    const retryDisabled = jcr.retryDisabled ? jcr.retryDisabled : false;
    const maxWidth = jcr.maxWidth ? `max-width:${jcr.maxWidth}` : '';
    const styles = `display: none;${maxWidth}`;
    let classNames = 'spa-card spa-card--medium spa-card--overlay spa-spin';
    classNames = `${classNames} ${pageLevel ? 'spa-spin-page-wrapper' : ''} ${jcr.className || ''} ${jcr.removeSpinnerShadow ? 'spa-spinner--remove-shadow' : ''}`;


    let spinner = `<div role="status" aria-live="polite" aria-atomic="true" class="${classNames}" style="${styles}">
        <div class="spa-spin-wrapper">
          <div class="spa-spin-content-wrapper">
            <div class="spa-spin-load-msg body-small">
              ${getSpinner()}
              <div class="spa-spin-msg-wrapper" style="visibility: hidden; ${loadingMessage === '' ? 'display: none;' : ''}">
                ${loadingMessage}
              </div>
            </div>

            <div class="spa-spin-cancel-msg" style="display: none;">
              <div class="spa-spin-cancel-title headline-xsmall">
                ${cancelTitle}
              </div>
              <div class="spa-spin-cancel-text body-small">
                ${cancelMessage}
              </div>
            </div>

            <div class="spa-spin-error-msg" style="display: none;">
              <div class="spa-spin-error-icon">
                <div class="spa-icon icon-warning-red"></div>
              </div>
              <div class="spa-spin-error-title headline-xsmall">
                ${errorTitle}
              </div>
              <div class="spa-spin-error-text body-small">
                ${errorMessage}
              </div>
            </div>

          </div>

          <div class="spa-spin-cancel-wrapper">
            <button class="spa-btn spa-btn--small spa-btn--link spa-spin-cancel-btn" ${cancelDisabled ? 'style="display: none"' : ''}>Cancel</button>
            <button class="spa-btn spa-btn--small spa-btn--link spa-spin-retry-btn ${retryDisabled ? 'spin-retry-disabled' : ''}" style="display: none;">Try Again</button>
          </div>

        </div>

      </div>
    `;


    if (pageLevel) spinner += '</div>';

    return new Handlebars.SafeString(spinner);
  },
};





class spinnerHelper {






  static register(Handlebars) {
    Object.keys(helpers).forEach((key) => {
      Handlebars.registerHelper(key, helpers[key]);
    });
  }






  static render(jcr) {
    return helpers.spinner(jcr);
  }
}

module.exports = spinnerHelper;
